import { round } from 'lodash';
import { InvestmentHistory } from '../../types';

const allocateUnitsProRataStrategy = (
  investmentHistory: InvestmentHistory,
  unitsSold: number,
  totalUnits: number,
) => {
  return investmentHistory.map((history) => {
    return {
      ...history,
      allocatedUnits:
        totalUnits && unitsSold
          ? round((history.currentNumberOfUnits / totalUnits) * unitsSold, 2)
          : 0,
    };
  });
};

export default allocateUnitsProRataStrategy;
